/**
 * colorOverlay
 */
import colorOverlay from './component'


export default {
  install(Vue, options) {
    Vue.component('color-overlay', colorOverlay)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/color-overlay/index.js